import { motion } from "framer-motion";
import { InvestorChapter } from "./InvestorChapter";

const spatialPose = ({ direction, mode, reducedMotion }, exiting = false) => {
  if (reducedMotion) return { opacity: 0, scale: exiting ? 1.015 : 0.985 };
  if (mode === 0) return { opacity: 0, x: `${direction * (exiting ? -18 : 22)}%`, z: -260, scale: 0.76, rotateY: direction * (exiting ? -14 : 18), filter: "blur(14px)" };
  if (mode === 1) return { opacity: 0, x: `${direction * (exiting ? -42 : 54)}%`, z: -120, scale: 0.88, rotateY: direction * (exiting ? -42 : 58), filter: "blur(10px)" };
  return { opacity: 0, y: `${direction * (exiting ? -16 : 20)}%`, z: -220, scale: 0.8, rotateX: direction * (exiting ? 16 : -24), filter: "blur(12px)" };
};

const variants = {
  enter: (state) => spatialPose(state),
  center: { opacity: 1, x: "0%", y: "0%", z: 0, scale: 1, rotateX: 0, rotateY: 0, filter: "blur(0px)" },
  exit: (state) => spatialPose(state, true),
};

export const InvestorScene = ({ chapter, data, onNext, direction, reducedMotion }) => {
  const motionState = { direction, mode: (chapter.id - 1) % 3, reducedMotion };
  return (
    <motion.div
      className="invest-scene-slot"
      custom={motionState}
      variants={variants}
      initial="enter"
      animate="center"
      exit="exit"
      transition={reducedMotion ? { duration: 0.22, ease: "easeOut" } : { duration: 0.72, ease: [0.22, 1, 0.36, 1] }}
      style={{ transformOrigin: direction > 0 ? "100% 50%" : "0% 50%" }}
      data-testid={`invest-scene-${chapter.id}`}
    >
      <InvestorChapter chapter={chapter} data={data} onNext={onNext} />
    </motion.div>
  );
};